import { create, devtools, persist } from 'lib/zustand';
import type { Layout } from '../types';
import type { Mode } from '../types/mode';

type CalendarAction = {
  reset: () => void;
  setCalendarSettings: (settings: Partial<CalendarSettingsState>) => void;
};

type CalendarSettingsState = {
  isOpen: boolean;
  layout: Layout;
  mode: Mode;
};

const initialState: { calendarSettings: CalendarSettingsState } = {
  calendarSettings: {
    isOpen: true,
    layout: 'calendar',
    mode: 'day',
  },
};

const useCalendarSettingsStore = create<{ calendarSettings: CalendarSettingsState } & CalendarAction>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        reset() {
          set(initialState);
        },
        setCalendarSettings(settings) {
          set((state) => ({ calendarSettings: { ...state.calendarSettings, ...settings } }));
        },
      }),
      {
        name: 'calendar-settings-storage',
      },
    ),
  ),
);

export const useCalendarSettings = (): [CalendarSettingsState, (settings: Partial<CalendarSettingsState>) => void] => [
  useCalendarSettingsStore((state) => state.calendarSettings),
  useCalendarSettingsStore((state) => state.setCalendarSettings),
];
